import React, { useState } from "react";
import {
  ReadingSettingsContext,
  ChineseCharacterMode,
} from "./chineseCharacterMode";

export const ChineseCharacterModeSettingsProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [chineseCharacterMode, setChineseCharacterModeState] =
    useState<ChineseCharacterMode>(
      () =>
        (localStorage.getItem(
          "chineseCharacterMode"
        ) as ChineseCharacterMode) || "default"
    );

  const setChineseCharacterMode = (mode: ChineseCharacterMode) => {
    setChineseCharacterModeState(mode);
    localStorage.setItem("chineseCharacterMode", mode);
  };

  return (
    <ReadingSettingsContext.Provider
      value={{ chineseCharacterMode, setChineseCharacterMode }}
    >
      {children}
    </ReadingSettingsContext.Provider>
  );
};
